import { jsx as _jsx } from "react/jsx-runtime";
import MenuIcon from '@ingka/ssr-icon/paths/menu';
import { SkapaButton } from '@inter-ikea-guida/skapa';
const GuidaMenuButton = ({ onClick, buttonText }) => {
    return (_jsx(SkapaButton, { type: 'primary', inverseTheme: true, iconOnly: true, ssrIcon: MenuIcon, onClick: onClick, text: buttonText, dataTestId: 'guida-menu' }));
};
export default GuidaMenuButton;
//# sourceMappingURL=GuidaMenuButton.js.map